(function () {
  const SECTION_SELECTOR = '[data-vx-swiper-slideshow]';
  const UPDATE_DELAYS = [0, 100, 300, 700];

  function refreshSwiper(section) {
    const swiper = section?._vxSwiperInstance;
    if (!swiper || swiper.destroyed) return;

    swiper.update();
    swiper.slideToLoop?.(swiper.realIndex || 0, 0, false);
  }

  function scheduleRefreshes(section) {
    requestAnimationFrame(() => refreshSwiper(section));

    UPDATE_DELAYS.forEach((delay) => {
      window.setTimeout(() => refreshSwiper(section), delay);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.vxSwiperInitialized === 'true' || typeof window.Swiper === 'undefined') return;

    const slider = section.querySelector('[data-vx-swiper-slider]');
    const pagination = section.querySelector('[data-vx-swiper-pagination]');
    if (!slider || !pagination) return;

    const slideCount = Number(section.dataset.slideCount || '0');
    if (slideCount === 0) return;

    const slideBetween = Number(section.dataset.slideBetween || '0');
    const slideWidth = Number(section.dataset.slideWidth || '85');
    const rawSlideDuration = Number(section.dataset.slideDuration || '500');
    const slideDuration = rawSlideDuration < 100 ? rawSlideDuration * 1000 : rawSlideDuration;
    const transitionSpeed = Number(section.dataset.transitionSpeed || '300');
    const autoplayEnabled = section.dataset.autoplay === 'true' && slideCount > 1;
    const loopEnabled = section.dataset.loop === 'true' && slideCount > 2;

    section.style.setProperty('--vartix-slide-width', `${Math.min(Math.max(slideWidth, 20), 100)}%`);

    section._vxSwiperInstance = new window.Swiper(slider, {
      allowTouchMove: true,
      autoHeight: false,
      autoplay: autoplayEnabled
        ? {
            delay: slideDuration,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            waitForTransition: false
          }
        : false,
      centeredSlides: true,
      grabCursor: true,
      loop: loopEnabled,
      loopAdditionalSlides: 1,
      nested: false,
      pagination: {
        clickable: true,
        el: pagination,
        renderBullet(index, className) {
          return `<button class="${className}" type="button" aria-label="Go to slide ${index + 1}"></button>`;
        }
      },
      preventClicks: false,
      preventClicksPropagation: false,
      simulateTouch: true,
      slidesPerGroup: 1,
      slidesPerView: 'auto',
      spaceBetween: Math.max(slideBetween, 0),
      speed: Math.max(transitionSpeed, 100),
      touchStartPreventDefault: false,
      updateOnWindowResize: true,
      watchSlidesProgress: true,
      watchOverflow: false
    });

    slider.querySelectorAll('img').forEach((image) => {
      if (image.complete) {
        refreshSwiper(section);
        return;
      }

      image.addEventListener(
        'load',
        () => {
          scheduleRefreshes(section);
        },
        { once: true }
      );
    });

    scheduleRefreshes(section);
    section.dataset.vxSwiperInitialized = 'true';
  }

  function destroySection(section) {
    if (!section?._vxSwiperInstance) return;

    section._vxSwiperInstance.destroy(true, true);
    section._vxSwiperInstance = null;
    section.dataset.vxSwiperInitialized = 'false';
  }

  function initWithin(container) {
    if (!container) return;

    if (container.matches && container.matches(SECTION_SELECTOR)) {
      initSection(container);
    }

    container.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  function destroyWithin(container) {
    if (!container) return;

    if (container.matches && container.matches(SECTION_SELECTOR)) {
      destroySection(container);
    }

    container.querySelectorAll?.(SECTION_SELECTOR).forEach(destroySection);
  }

  document.addEventListener('DOMContentLoaded', () => initWithin(document));
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:reorder', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
  window.addEventListener('load', () => initWithin(document));
}());
